export function searchDiscounts(discounts, searchTerm) {
  if (!Array.isArray(discounts) || discounts.length === 0) return [];

  const term = searchTerm
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return discounts.filter((discount) => {
    return (
      !term ||
      discount.name?.toLowerCase().includes(term) ||
      discount.code?.toLowerCase().includes(term)
    );
  });
}
